import { api } from "@/redux/api";

import {
	SupportTicketRequest,
	SupportTicketResponse,
	SupportTicketResponseSchema,
} from "./helpCenter.schema";

/**
 * The chat itself is not here: it streams, and RTK Query buffers a whole response before it
 * resolves. It is read from `fetch` directly in `useHelpChatStream`.
 */
export const helpCenterApi = api.injectEndpoints({
	endpoints: (builder) => ({
		createSupportTicket: builder.mutation<SupportTicketResponse, SupportTicketRequest>({
			query: (body) => ({
				url: "help-center/support-ticket",
				method: "POST",
				body,
				responseSchema: SupportTicketResponseSchema,
			}),
		}),
	}),
});

export const { useCreateSupportTicketMutation } = helpCenterApi;
